<template>
    <div class="main-content">
        <div class="container">
            <div class="header-section">
                <h1>Single Cell Datasets</h1>
                <p class="lead">Browse and search available single-cell datasets</p>
            </div>
            
            <div class="panel">
                <el-row :gutter="20">
                  <el-col :span="5">
                    <div class="sidebar-title">Tissue Filter</div>
                        <div class="tree-wrapper">
                            <div class="tree-box">
                                <el-tree :expand-on-click-node="false" :data="form1.treeData" node-key="id"
                                    :props="{ label: 'name' }" :default-expanded-keys="form1.expandNode"
                                    @node-click="handleClickTree1" />
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="19">
                        <div class="search-bar">
                            <el-form :inline="true" ref="searchForm1" :model="searchForm1" @submit.native.prevent>
                                <el-form-item>
                                    <el-input class="custom-input" v-model="searchForm1.organism"
                                        placeholder="Search organism..." prefix-icon="el-icon-search" />
                                </el-form-item>
                                <el-form-item>
                                    <el-input class="custom-input" v-model="form1.tissue"
                                        placeholder="Search tissue..." prefix-icon="el-icon-search" />
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="onFormSearch1">Search</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        
                        <el-table :data="form1.tableData" empty-text="No data available" 
                            @sort-change="handleTableSortChange1" @row-click="handleRowClick1"
                            @selection-change="handleSelectionChange1" :row-class-name="getTableRowStyle1"
                            class="custom-table">
                            <el-table-column prop="singleCell" label="Name" min-width="150" sortable="custom" >
                              <template slot-scope="scope">
                                    <a :href="'/#/singleCell/detail/' + scope.row.id" class="table-link">
                                        {{ scope.row.name }}
                                    </a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="organism" label="Organism" width="120" sortable="custom">
                            </el-table-column>
                            <el-table-column prop="tissue" label="Tissue" width="120" sortable="custom">
                            </el-table-column>
                            <el-table-column prop="notes" label="Notes" width="120" sortable="custom">
                                <template slot-scope="scope">
                                    <el-popover trigger="hover" placement="top">
                                        <p>{{ scope.row.notes }}</p>
                                        <div slot="reference" class="name-wrapper">
                                            <span class="truncate-text">{{ scope.row.notes }}</span>
                                        </div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="dataAccession" label="Data accession" width="140" sortable="custom">
                            </el-table-column>
                            <el-table-column prop="dataSource" label="Data source" width="120" sortable="custom">
                            </el-table-column>
                            <el-table-column prop="dataLink" label="Data link" width="100">
                              <template slot-scope="scope">
                                    <a v-if="scope.row.dataLink" :href="scope.row.dataLink" target="_blank" class="external-link">
                                        <i class="el-icon-link"></i> Link
                                    </a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="condition" label="Condition" width="120" sortable="custom">
                            </el-table-column>
                            <el-table-column prop="pmid" label="PMID" width="100" sortable="custom">
                              <template slot-scope="scope">
                                    <a :href="'https://pubmed.ncbi.nlm.nih.gov/' + scope.row.pmid" target="_blank" class="external-link">
                                        {{ scope.row.pmid }}
                                    </a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="paper" label="Paper" min-width="150" sortable="custom">
                            </el-table-column>
                        </el-table>
                        
                        <div class="pagination-wrapper">
                            <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                                :current-page="form1.pageNum" :page-sizes="[10, 20, 50]" :page-size="form1.pageSize"
                                layout="total, sizes, prev, pager, next" :total="form1.total">
                            </el-pagination>
                        </div>
                    </el-col>
                </el-row>
                
                <!-- <div class="selection-info" v-if="form1.selectedRow.diseaseId">
                    <span class="label">Selected Disease:</span> {{ form1.selectedRow.diseaseName }} 
                    <span class="id-badge">ID: {{ form1.selectedRow.diseaseId }}</span>
                </div> -->
            </div>
            
            <div style="margin-bottom: 40px;"></div>
        </div>
    </div>
</template>

<script>
import table_mix from "@/common/table_mix";

export default {
    name: "SingleCellList",
    mixins: [table_mix],
    props: ['sourceType'],

    data() {
        return {
            form1: {
                organism: '',
                treeData: [],
                expandNode: [],
                tableData: [],
                pageNum: 1,
                pageSize: 10,
                total: 0,
                tissue: '',
                selectedRow: {},
                selectedRows: []
            },

            searchForm1: {
                organism: ''
            },

            searchForm1Rule: {
                organism: [{ required: true, message: "organism cannot be empty", trigger: "blur" }],
            },
        };
    },

    created() {
        if (this.$route.query.tissue) {
            this.form1.tissue = this.$route.query.tissue;
        }
        this.handleGetTreeData1();
        this.refreshTable1();
    },

    methods: {

        handleCurrentChange1(val) {
            this.form1.pageNum = val
            this.refreshTable1()
        },

        handleSizeChange1(val) {
            this.form1.pageSize = val
            this.refreshTable1()
        },

        handleOrganismChange() {
            this.onFormSearch1()
        },

        handleRowClick1(row, column, e) {
            this.form1.selectedRow = row;
        },

        handleRadioChange1(e, row) {
            e.stopPropagation();
            this.form1.selectedRow = row
        },

        handleSelectionChange1(val) {
            this.form1.selectedRows = val;
        },

        async refreshTable(type, pageNum, pageSize, tissue, organism, excludeGwashugId, orderBy, orderDirection) {
            let q = 'type=' + type;
            if (pageNum) {
                q = q + '&pageNum=' + pageNum
            }
            if (pageSize) {
                q = q + '&pageSize=' + pageSize
            }
            if (tissue) {
                q = q + '&tissue=' + tissue
            }
            if (organism) {
                q = q + '&organism=' + organism
            }
            if (excludeGwashugId) {
                q = q + '&excludeGwashugId=' + excludeGwashugId
            }
            if (orderBy) {
                q = q + '&orderBy=' + orderBy
            }
            if (orderDirection) {
                q = q + '&orderDirection=' + orderDirection
            }

            const res = await this.$ajax.get('singleCell/page?' + q);
            return res.data;
        },

        async refreshTable1() {
            let sourceType = 1
            if (this.sourceType) {
                sourceType = this.sourceType
            }
            const data = await this.refreshTable(sourceType, this.form1.pageNum, this.form1.pageSize, this.form1.tissue, this.searchForm1.organism, '', this.form1.orderBy, this.form1.orderDirection)
            this.form1.tableData = data.records;
            this.form1.total = data.total;
        },

        async onFormSearch1() {
            let sourceType = 1
            if (this.sourceType) {
                sourceType = this.sourceType
            }
            const data = await this.refreshTable(sourceType, 1, this.form1.pageSize, this.form1.tissue, this.searchForm1.organism, '', this.form1.orderBy, this.form1.orderDirection)
            this.form1.pageNum = 1;
            this.form1.tableData = data.records;
            this.form1.total = data.total;
        },

        async handleClickTree1(data) {
            this.form1.tissue = data.id;
            this.refreshTable1();
        },

        async handleGetTreeData1() {
            let res = await this.$ajax.get("singleCell/tissues");
            let treeData = (res.data || []).map(t => ({ id: t, name: t }));
            this.form1.treeData = treeData;
            // Expand all nodes (though it's flat now)
            treeData.forEach(v => {
                this.form1.expandNode.push(v.id);
            });
        },

        async handleTableSortChange1(column) {
            const { prop, order } = column;

            if (order) {
                this.form1.orderBy = prop
                this.form1.orderDirection = order
            } else {
                this.form1.orderBy = ''
                this.form1.orderDirection = ''
            }


            this.refreshTable1()
        },

        getTableRowStyle1({ row, index }) {
            if (row.id == this.form1.selectedRow.id) {
                return 'selected-row'
            } else {
                return ''
            }
        },
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Playfair+Display:wght@600;700&display=swap');

.main-content {
    background-color: var(--bg);
    min-height: 100vh;
    padding: 30px 0;
    font-family: 'Inter', sans-serif;
    color: var(--navy);
}

.container {
    padding: 0 20px;
}

.header-section {
    margin-bottom: 30px;
    text-align: center;
}

h1 {
    font-family: 'Playfair Display', serif;
    font-size: 42px;
    font-weight: 700;
    color: var(--navy);
    margin: 0 0 10px 0;
}

.lead {
    color: var(--muted);
    font-size: 18px;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
}

.panel {
    background: linear-gradient(180deg, #f9fbfe 0%, #d8e1ee 100%);
    border: 1px solid var(--border);
    border-radius: 20px;
    padding: 30px;
    box-shadow: var(--shadow);
}

.sidebar-title {
    font-family: 'Playfair Display', serif;
    font-size: 20px;
    font-weight: 600;
    color: var(--navy);
    margin-bottom: 15px;
    border-bottom: 2px solid var(--accent);
    padding-bottom: 8px;
    display: inline-block;
}

.tree-wrapper {
    background: rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    padding: 15px;
    border: 1px solid var(--border);
    max-height: 600px;
    overflow-y: auto;
}

.tree-box {
    /* Custom scrollbar styles if needed */
}

/* Override Element UI Tree */
::v-deep .el-tree {
    background: transparent;
    color: var(--navy);
}

::v-deep .el-tree-node__content:hover {
    background-color: rgba(93, 135, 181, 0.15);
    border-radius: 6px;
}

::v-deep .el-tree-node__label {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
}

.search-bar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

/* Custom Input */
::v-deep .custom-input .el-input__inner {
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 20px 16px;
    background: rgba(255, 255, 255, 0.8);
    color: var(--navy);
    font-family: 'Inter', sans-serif;
    box-shadow: 0 4px 12px rgba(0,0,0,0.03);
    transition: all 0.3s ease;
    width: 300px;
}

::v-deep .custom-input.el-input--prefix .el-input__inner {
    padding-left: 40px;
}

::v-deep .custom-input.el-input--suffix .el-input__inner {
    padding-right: 40px;
}

::v-deep .custom-input .el-input__inner:focus {
    border-color: var(--accent);
    box-shadow: 0 0 0 3px rgba(93, 135, 181, 0.2);
}

/* Custom Button */
::v-deep .el-button--primary {
    background: var(--accent);
    border: 1px solid var(--accent);
    border-radius: 12px;
    padding: 12px 24px;
    font-weight: 700;
    color: #0c1724;
    box-shadow: 0 8px 16px rgba(93, 135, 181, 0.2);
    font-family: 'Inter', sans-serif;
    transition: all 0.3s ease;
}

::v-deep .el-button--primary:hover {
    background: #4a7095;
    border-color: #4a7095;
    transform: translateY(-2px);
    box-shadow: 0 12px 20px rgba(93, 135, 181, 0.3);
}

/* Custom Table */
::v-deep .el-table {
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.05);
    background-color: rgba(255, 255, 255, 0.9);
}

::v-deep .el-table th {
    background-color: rgba(93, 135, 181, 0.15) !important;
    color: var(--navy);
    font-family: 'Playfair Display', serif;
    font-weight: 700;
    font-size: 15px;
    padding: 16px 0;
    border-bottom: 1px solid rgba(93, 135, 181, 0.2);
}

::v-deep .el-table td {
    padding: 14px 0;
    font-family: 'Inter', sans-serif;
    color: var(--muted);
    border-bottom: 1px solid rgba(199, 209, 221, 0.5);
}

::v-deep .el-table tr:hover > td {
    background-color: rgba(93, 135, 181, 0.08) !important;
}

.table-link {
    color: var(--accent);
    font-weight: 600;
    text-decoration: none;
    transition: color 0.2s;
}

.table-link:hover {
    color: var(--navy);
    text-decoration: underline;
}

.external-link {
    color: var(--muted);
    transition: color 0.2s;
}

.external-link:hover {
    color: var(--accent);
}

.pagination-wrapper {
    margin-top: 30px;
    text-align: center;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: var(--accent);
    color: #fff;
}

.selection-info {
    margin-top: 20px;
    padding: 15px;
    background: rgba(255, 255, 224, 0.8);
    border-radius: 10px;
    border: 1px solid rgba(255, 215, 0, 0.3);
    text-align: center;
}

.selection-info .label {
    font-weight: 700;
    color: var(--navy);
}

.selection-info .id-badge {
    background: var(--navy);
    color: #fff;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    margin-left: 10px;
}

.truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
    cursor: pointer;
}

/* Scrollbar styling */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: rgba(0,0,0,0.05);
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    background: rgba(93, 135, 181, 0.5);
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(93, 135, 181, 0.8);
}

</style>
